import { AdoptionAttemptDto, AdoptionAttemptDtoStatus } from '../interactors/gen/backendClient'

export const isAdoptionAttemptOutsidePetso = (
  adoptionAttempt?: Pick<AdoptionAttemptDto, 'procedureOrigin'> | null
): boolean => adoptionAttempt?.procedureOrigin === 'outside-petso'

export const isDoneOutsidePetsoAttempt = (
  adoptionAttempt?: Pick<AdoptionAttemptDto, 'procedureOrigin' | 'status'> | null
): boolean =>
  adoptionAttempt?.status === AdoptionAttemptDtoStatus.Done && isAdoptionAttemptOutsidePetso(adoptionAttempt)

export const usesManualDocumentFlow = (
  adoptionAttempt?: Pick<AdoptionAttemptDto, 'withoutDocumentsSupport'> | null
): boolean => adoptionAttempt?.withoutDocumentsSupport === true

export const isPetsoAttemptWithManualDocuments = (
  adoptionAttempt?: Pick<AdoptionAttemptDto, 'procedureOrigin' | 'withoutDocumentsSupport'> | null
): boolean => !isAdoptionAttemptOutsidePetso(adoptionAttempt) && usesManualDocumentFlow(adoptionAttempt)
